import React, { useEffect, useState } from 'react';
import CustomInput from '../../Components/CommonComponents/CustomInput';
import CustomSelect from '../../Components/CommonComponents/CustomSelect';
import CustomTextarea from '../../Components/CommonComponents/CustomTextarea';
import statesData from '../../Files/states.json';
import { RefrenceList, educationLevels, indianStatesAndUTs, statusOptions, religionOptions } from '../../Files/dropdownOptions';
import axios from 'axios';
import { UploadFile, END_POINT, RemoveFile, UploadImages, DeleteImages } from '../../Redux/AdminReducer/action';
import CustomButton from '../../Components/CommonComponents/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaRegStar, FaStar } from 'react-icons/fa';
import AfterActionComponent from './actionView';

// Public pages have no login token, so the backend picks the clinic database
// from the frontend host.
const tenantHeaders = () => ({ 'X-Frontend-Host': window.location.host });

const createItem = async (data, navigate, setIsPorcessing, setSelectedPatient, setOperateType) => {
  try {
    const result = await axios.post(`${END_POINT}/feedback`, data, { headers: tenantHeaders() });
    setSelectedPatient(result?.data);
    setIsPorcessing(false);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    toast.success('Created Successfully');
    return result?.data._id;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
  }
};

const submitComments = async (patientId, rating, comments, signature, setIsPorcessing, setOperateType, navigate) => {
  try {
    const feedbackData = {
      date: new Date().toISOString().slice(0, 10),
      content: comments,
      signature,
      rating,
    };
    await axios.put(`${END_POINT}/feedback/${patientId}`, { comments: feedbackData }, { headers: tenantHeaders() });
    setIsPorcessing(false);
    setOperateType(null);
    toast.success('Comments submitted successfully');
    const isPublic = window.location.pathname.startsWith('/public');
    navigate(isPublic ? `/public/afterAction` : `/web/afterAction`);
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong');
    toast.error('Failed to submit comments');
    setIsPorcessing(false);
    console.error(error);
  }
};

const fetchItems = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`, { headers: tenantHeaders() });
    return result;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log(error);

    toast.error('Something went wrong while fetching data');
  }
};

const initialFormData = {
  FirstName: '',
  MiddleName: '',
  LastName: '',
  dateOfBirth: '',
  bloodGroup: '',
  gender: '',
  mobile: '',
  maritalStatus: '',
  motherTongue: '',
  religion: '',
  state: '',
  education: '',
  address: '',
  profession: '',
  industry: '',
  email: '',
  Status: '',
  CaseNo: '',
  Date: '',
  complaints: Array.from({ length: 10 }, () => ({ content: '' })),
};

const initialFormError = { ...initialFormData };

const initialFormDataForUpdate = {
  comments: '',
  CaseRating: 0,
  Signature: '',
};

const initialFormDataForUpdateError = { ...initialFormDataForUpdate };

// Naming the stars tells the patient what a rating means, so a 3 from one person
// means roughly what a 3 from the next one does.
const RATING_LABELS = {
  1: 'Poor',
  2: 'Fair',
  3: 'Good',
  4: 'Very good',
  5: 'Excellent',
};

export const FeedBack = () => {
  const { patientId } = useParams();
  const [formData, setFormData] = useState(initialFormData);
  const [formError, setFormError] = useState(initialFormError);
  const [FormDataForUpdate, setFormDataForUpdate] = useState(initialFormDataForUpdate);
  const [patientList, setPatientList] = useState([]);
  const [operateType, setOperateType] = useState(null);
  const navigate = useNavigate();
  const [isProcessing, setIsPorcessing] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [currentPatientInfo, setCurrentPatientInfo] = useState(null);
  const [formErrorForUpdate, setFormErrorForUpdate] = useState(initialFormDataForUpdateError);
  const [hoverRating, setHoverRating] = useState(0);

  const patientName = [currentPatientInfo?.FirstName, currentPatientInfo?.LastName].filter(Boolean).join(' ');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInputUpdateChange = (event) => {
    const { name, value } = event.target;

    setFormDataForUpdate((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const messages = { comments: 'Comments are required!', Signature: 'Signature is required!' };
    if (messages[name]) {
      setFormErrorForUpdate((prev) => ({ ...prev, [name]: value.trim() ? '' : messages[name] }));
    }
  };

  useEffect(() => {
    if (patientId) {
      setSelectedPatient(patientId);
      setOperateType('comment');
      fetchItems(`feedback/${patientId}`).then((res) => {
        if (res?.data) {
          setCurrentPatientInfo(res.data);
          if (res.data.CaseRating) {
            setFormDataForUpdate((prev) => ({
              ...prev,
              CaseRating: res.data.CaseRating,
            }));
          }
        }
      });
    } else {
      fetchItems('feedback/patients').then((res) => {
        setPatientList(res?.data || []);
      });
    }
  }, [patientId]);

  const handleForm = () => {
    const trimmedFormData = { ...formData };
    let isValidInput = true;

    for (const key in trimmedFormData) {
      if (trimmedFormData?.hasOwnProperty(key)) {
        if (typeof trimmedFormData[key] === 'string') {
          trimmedFormData[key] = trimmedFormData[key].trim();
        }
      }
    }

    if (isValidInput) {
      setIsPorcessing(true);
      createItem(trimmedFormData, navigate, setIsPorcessing, setSelectedPatient, setOperateType);
    }
  };

  const handleFormUpdate = () => {
    const trimmedFormData = { ...FormDataForUpdate };
    let isValidInput = true;

    for (const key in trimmedFormData) {
      if (trimmedFormData?.hasOwnProperty(key)) {
        if (typeof trimmedFormData[key] === 'string') {
          trimmedFormData[key] = trimmedFormData[key].trim();
        }
      }
    }

    if (!trimmedFormData.comments || !trimmedFormData.comments.trim()) {
      toast.error('Comments are required!');
      isValidInput = false;
      return;
    }
    if (!trimmedFormData.Signature || !trimmedFormData.Signature.trim()) {
      toast.error('Signature is required!');
      isValidInput = false;
      return;
    }

    if (isValidInput) {
      setIsPorcessing(true);
      submitComments(selectedPatient, trimmedFormData.CaseRating, trimmedFormData.comments, trimmedFormData.Signature, setIsPorcessing, setOperateType, navigate);
    }
  };

  const handleSelectChange = (event) => {
    const selectedPatientName = event.target.value;
    let selectedPatientId = patientList.find((patient) => patient?.FirstName === selectedPatientName)?._id;

    setSelectedPatient(selectedPatientId);
    setOperateType('comment');
  };

  const handleAddButton = (event) => {
    setOperateType('add');
    setSelectedPatient(null);
    setFormData(initialFormData);
  };
  const handleStarRating = (rating) => {
    console.log('Updating rating:', rating);
    setFormDataForUpdate((prevData) => ({
      ...prevData,
      CaseRating: rating,
    }));
  };

  const handleComplaintChange = (index, value) => {
    const updatedComplaints = [...formData.complaints];
    updatedComplaints[index]['content'] = value;

    setFormData({
      ...formData,
      complaints: updatedComplaints,
    });
  };

  return (
    <>
      {!patientId && (
        <div className="w-full justify-between mx-auto w-full px-5 flex pt-4">
          {operateType !== 'add' && <CustomSelect onChange={handleSelectChange} options={patientList?.map((e) => e?.FirstName)} label="Patient" placeholder="-- Select Patient Reference --" type="text" value={patientList?.filter((p) => p?._id === selectedPatient)?.[0]?.FirstName} error={formError.reference} name="reference" />}
          <div className="groupofButtons flex gap-10">
            {operateType !== 'add' && (
              <button className="w-fit p-3 mt-6 font-bold bg-primary-200 text-white h-12 rounded" onClick={handleAddButton}>
                Add New
              </button>
            )}

            <button className="w-fit p-3 mt-6 font-bold bg-primary-200 text-white h-12 rounded" onClick={() => setOperateType(null)}>
              Back
            </button>
          </div>
        </div>
      )}

      {operateType == 'add' && (
        <div className="p-20">
          <div className="bg-primary-50 pb-8 rounded-md pt-4 border-2 border-primary-400 ">
            <div className="pb-8 rounded-md pt-4">
              <div className="px-6 py-6 rounded-md">
                <div className="grid grid-cols-3 gap-x-6">
                  <CustomInput onChange={handleInputChange} label="Status" placeholder="Enter Status" type="text" value={formData.Status} error={formError.Status} name="Status" />
                  <CustomInput onChange={handleInputChange} label="Case No" placeholder="Enter Case No" type="text" value={formData.CaseNo} error={formError.CaseNo} name="CaseNo" />
                  <CustomInput onChange={handleInputChange} label="Date  " type="date" value={formData.Date} error={formError.Date} name="Date" />
                </div>
              </div>
            </div>

            <div className="pb-8 rounded-md pt-4 flex column">
              <div className="px-6 py-6 rounded-md">
                <h2 className="text-2xl font-semibold text-primary-900">Patient Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                  <CustomInput onChange={handleInputChange} label="First Name" placeholder="Enter First Name" type="text" value={formData.FirstName} error={formError.FirstName} name="FirstName" />
                  <CustomInput onChange={handleInputChange} label="Middle Name" placeholder="Enter Middle Name" type="text" value={formData.MiddleName} error={formError.MiddleName} name="MiddleName" />
                  <CustomInput onChange={handleInputChange} label="Last Name" placeholder="Enter Last Name" type="text" value={formData.LastName} error={formError.LastName} name="LastName" />
                  <CustomInput onChange={handleInputChange} label="Date of Birth" placeholder="Enter Date of Birth" type="date" value={formData.dateOfBirth} error={formError.dateOfBirth} name="dateOfBirth" />
                  <CustomSelect onChange={handleInputChange} options={['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-']} label={'Blood Group'} value={formData?.bloodGroup} error={formError?.bloodGroup} name="bloodGroup" placeholder="-- Select Blood Group --" />
                  <CustomSelect onChange={handleInputChange} options={['Male', 'Female', 'Other']} label="Gender" value={formData?.gender} error={formError?.gender} name="gender" placeholder="-- Select Gender --" />
                  <CustomInput onChange={handleInputChange} label="Mobil Number" placeholder="09999999999" type="number" value={formData?.mobile} error={formError?.mobile} name="mobile" />
                  <CustomSelect onChange={handleInputChange} options={['Single', 'Married', 'Divorced', 'Widow']} label="Marital Status" value={formData?.maritalStatus} error={formError?.maritalStatus} name="maritalStatus" placeholder="-- Select Marital Status --" />
                  <CustomSelect onChange={handleInputChange} options={['English', 'Spanish', 'French', 'German', 'Hindi', 'Chinese', 'Other']} label="Mother Tongue" value={formData?.motherTongue} error={formError?.motherTongue} name="motherTongue" placeholder="-- Select Mother Tongue --" />
                  <CustomSelect onChange={handleInputChange} options={religionOptions} label="Religion" value={formData?.religion} error={formError?.religion} name="religion" placeholder="-- Select Religion --" />
                  <CustomSelect onChange={handleInputChange} options={indianStatesAndUTs} label="State" value={formData.state} error={formError.state} name="state" placeholder="-- Select State --" />
                  <CustomSelect onChange={handleInputChange} options={['High School', 'Associate Degree', "Bachelor's Degree", "Master's Degree", 'Doctorate', 'Other']} label="Education" value={formData?.education} error={formError?.education} name="education" placeholder="-- Select Education Level --" />
                  <CustomInput label="Address" value={formData?.address} onChange={handleInputChange} name="address" placeholder="Enter your address" error={formError?.address} />
                  <CustomInput label="Profession" value={formData?.profession} onChange={handleInputChange} name="profession" placeholder="Enter your profession" error={formError?.profession} />
                  <CustomInput label="Industry" value={formData?.industry} onChange={handleInputChange} name="industry" placeholder="Enter your industry" error={formError?.industry} />
                  <CustomInput label="Email ID" value={formData?.email} onChange={handleInputChange} name="email" placeholder="Enter your email address" error={formError?.email} />
                </div>
              </div>

              <div className="pb-8 rounded-md pt-4">
                <div className="px-6 py-6 rounded-md ">
                  <h2 className="text-2xl font-semibold text-primary-400  border-l-4 border-primary-400 pl-3 mb-2">Present set of Complaints</h2>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                      {console.log(formData?.complaints)}
                      {formData?.complaints?.map((complaint, index) => (
                        <div key={index}>
                          <label className="block text-sm font-medium text-gray-700">{`Complaint ${index + 1}`}</label>
                          <input type="text" value={complaint?.content} onChange={(e) => handleComplaintChange(index, e.target.value)} className="mt-1 p-2 block w-full border rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:outline-none" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-80 mx-auto w-full px-5  ">
              <CustomButton onClick={handleForm} isProcessing={isProcessing} label={'Submit'} />
            </div>
          </div>
        </div>
      )}

      {selectedPatient !== null && (
        <div className="min-h-screen bg-slate-50">
          <div className="mx-auto w-full max-w-2xl px-4 py-8 sm:px-6 sm:py-12">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-500">
                  <FaRegStar className="h-5 w-5" />
                </div>
                <div className="min-w-0">
                  <h1 className="text-xl font-bold text-slate-900 sm:text-2xl">How was your experience?</h1>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">
                    {patientName ? (
                      <>
                        Thank you for visiting us, <span className="font-semibold text-slate-800">{patientName}</span>. Your
                        feedback helps us take better care of you and everyone after you.
                      </>
                    ) : (
                      'Your feedback helps us take better care of you and everyone after you.'
                    )}
                  </p>
                </div>
              </div>

              <div className="mt-8">
                <label className="block text-sm font-semibold text-slate-800">Rate your experience</label>
                <div className="mt-2 flex items-center gap-1">
                  {[...Array(5)]?.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => handleStarRating(index + 1)}
                      onMouseEnter={() => setHoverRating(index + 1)}
                      onMouseLeave={() => setHoverRating(0)}
                      className="rounded-lg p-1 transition hover:scale-110 focus:outline-none focus:ring-2 focus:ring-amber-400/40"
                      aria-label={`${index + 1} out of 5`}
                    >
                      <FaStar
                        className={`h-8 w-8 transition-colors ${
                          index < (hoverRating || FormDataForUpdate?.CaseRating || 0) ? 'text-amber-400' : 'text-slate-200'
                        }`}
                      />
                    </button>
                  ))}
                  <span className="ml-3 text-sm font-medium text-slate-500">
                    {RATING_LABELS[hoverRating || FormDataForUpdate?.CaseRating] || 'Tap a star'}
                  </span>
                </div>
              </div>

              <div className="mt-8">
                <label htmlFor="comments" className="block text-sm font-semibold text-slate-800">
                  Tell us more
                </label>
                <p className="mt-0.5 text-xs text-slate-500">What went well, and what could we do better?</p>
                <textarea
                  id="comments"
                  name="comments"
                  rows={6}
                  value={FormDataForUpdate?.comments || ''}
                  onChange={handleInputUpdateChange}
                  placeholder="Share your experience…"
                  className={`mt-2 w-full resize-y rounded-xl border bg-white px-3.5 py-2.5 text-sm text-slate-800 shadow-sm outline-none transition placeholder:text-slate-400 hover:border-slate-300 focus:ring-2 focus:ring-amber-500/20 ${
                    formErrorForUpdate?.comments ? 'border-rose-300 focus:border-rose-400' : 'border-slate-200 focus:border-amber-500'
                  }`}
                />
                {formErrorForUpdate?.comments && <p className="mt-1 text-xs text-rose-600">{formErrorForUpdate.comments}</p>}
              </div>

              <div className="mt-6">
                <label htmlFor="Signature" className="block text-sm font-semibold text-slate-800">
                  Your name
                </label>
                <p className="mt-0.5 text-xs text-slate-500">Typing your name here counts as your signature.</p>
                <input
                  id="Signature"
                  name="Signature"
                  type="text"
                  value={FormDataForUpdate?.Signature || ''}
                  onChange={handleInputUpdateChange}
                  placeholder="Enter your full name"
                  className={`mt-2 w-full rounded-xl border bg-white px-3.5 py-2.5 text-sm text-slate-800 shadow-sm outline-none transition placeholder:text-slate-400 hover:border-slate-300 focus:ring-2 focus:ring-amber-500/20 ${
                    formErrorForUpdate?.Signature ? 'border-rose-300 focus:border-rose-400' : 'border-slate-200 focus:border-amber-500'
                  }`}
                />
                {formErrorForUpdate?.Signature && <p className="mt-1 text-xs text-rose-600">{formErrorForUpdate.Signature}</p>}
              </div>

              <button
                type="button"
                onClick={handleFormUpdate}
                disabled={isProcessing}
                className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800 active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {isProcessing ? (
                  <>
                    <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Sending…
                  </>
                ) : (
                  'Submit Feedback'
                )}
              </button>

              <p className="mt-4 text-center text-xs text-slate-400">Your feedback goes directly to your treating doctor.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
